import { InjectionToken } from '@angular/core';

/**
 * Runtime values for public marketing pages (About, Contact, Register interest) and public API base URL.
 * Each app provides this from its environment; the library must not import app `environments/`.
 */
export interface PublicMarketingRuntimeConfig {
  /** Base API URL without trailing slash; used for public lead POST and inline form gating. */
  apiUrl: string;
  appName: string;
  appSubtitle: string;
  contactEmail: string;
  registerInterestUrl: string;
  environmentName: string;
  production: boolean;
}

export const PUBLIC_MARKETING_RUNTIME_CONFIG = new InjectionToken<PublicMarketingRuntimeConfig>(
  'PUBLIC_MARKETING_RUNTIME_CONFIG',
);
